export default {
  title: "Nutzungsbasierte Bezahlung",
  subtitle: "Kaufen Sie Guthaben nach Bedarf, kein Abonnement erforderlich",
  calculation_title: "Kohlenstoffemissionsberechnungen",
  report_title: "Berichte",
  combo_title: "Kombi-Pakete",
  combo_subtitle: "Sparen Sie mehr mit unseren Kombi-Paketen",
  select_quantity: "Menge auswählen",
  select_package: "Paket auswählen",
  total: "Gesamt",
  calculation_credits: "Berechnungsguthaben",
  report_credits: "Berichtsguthaben",
  credits: "Guthaben",
  price: "Preis",
  buy_now: "Jetzt kaufen",
  starter_pack: "Starter-Paket",
  professional_pack: "Professional-Paket",
  enterprise_pack: "Enterprise-Paket",
  save_x_percent: "Sparen Sie {percent} %",
  note: "Das von Ihnen gekaufte Guthaben läuft nie ab.",
  expiry_note:
    "Sie können es jederzeit nutzen. Zukünftig werden optionale Guthaben-Erweiterungs- oder -Konvertierungsfunktionen verfügbar sein.",
  calculation_price: "Kohlenstoffemissionsberechnungen",
  report_price: "Berichte",
  calculation_price_dynamic: "{price} pro Berechnung",
  report_price_dynamic: "{price} pro Bericht",
  benefits: "Vorteile der nutzungsbasierten Bezahlung",
  future_features: "Zukünftige Funktionen",
  future_features_desc:
    "Wir planen, später optionale Guthaben-Erweiterungen und -Austauschfunktionen einzuführen. Derzeit ist keine Aktion erforderlich.",
  extension_option_future: "Guthaben-Erweiterung",
  extension_option_future_desc:
    "Verlängern Sie die Gültigkeit Ihres Guthabens gegen eine geringe Gebühr (in einer zukünftigen Version verfügbar).",
  credit_exchange_future: "Guthaben-Austausch",
  credit_exchange_future_desc:
    "Tauschen Sie ungenutztes oder abgelaufenes Guthaben gegen Testzugang in zukünftigen Versionen aus.",
  quantity: "Menge",
  ladder_pricing: "Staffelpreise",
  unit: "Einheit",
  pay_per_use_benefit1: "Kein Abonnement erforderlich",
  pay_per_use_benefit2: "Nur für das Bezahlen, was Sie nutzen",
  pay_per_use_benefit3: "Lebenslange Gültigkeit",
};
